import React from 'react';
import Form from "react-bootstrap/Form";
import BaseProps from "../../types/BaseProps";
import classNames from "classnames";

export type OptionProps = {
  id: string,
  label: string
};

type SelectMenuProps = BaseProps & {
  options: Array<OptionProps>;
  selected?: string;
  onChange?: (value: string) => void;
  // When the select menu is standalone, then it'll be wrapped in a form.
  // Otherwise a plain select menu will be rendered.
  standalone?: boolean;
  // The size of the select menu using the bootstrap options: "sm" or "lg"
  size?: 'sm' | 'lg';
  disabled?: boolean
};

/**
 * Simple select menu component. Wraps Bootstraps form select control.
 */
class SelectMenu extends React.Component<SelectMenuProps> {

  constructor(props: SelectMenuProps) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(event: any) {
    if (this.props.onChange) {
      const selectedValue = event.target.value;
      this.props.onChange(selectedValue);
    }
  }

  render() {
    const isStandalone = this.props.standalone !== undefined ? this.props.standalone : true;
    const options: Array<React.ReactElement> = [];
    if (this.props.options.length > 0) {
      // In case props.selected is not among props.options -> render the hidden option
      options.push(<option key="" hidden label=" -- Select -- "/>);
    }
    this.props.options.forEach(option => {
      options.push(<option key={option.id} value={option.id}>{option.label}</option>);
    });

    const control =
      <Form.Control as="select" custom className="SelectMenuControl" size={this.props.size || 'sm'}
                    onChange={this.onChange}
                    disabled={this.props.disabled}
                    value={this.props.selected}>
        {options}
      </Form.Control>;

    if (!isStandalone) {
      return control;
    }
    return (
      <Form className={classNames("SelectMenu", this.props.className)}>
        <Form.Group>
          {control}
        </Form.Group>
      </Form>
    );
  }
}

export default SelectMenu;
